export const SHOP_URL = 'https://shop.cave-la-colombe.ch/category/rouges'
